class SiteHeader extends HTMLElement {
  constructor() {
    super();
    // Future header-wide logic can go here
  }

  connectedCallback() {
    // This runs when the header is added to the DOM
    // Example: console.log('SiteHeader loaded');
  }
}

// Mobile drawer functionality
window.addEventListener('DOMContentLoaded', () => {
  const siteHeader = document.getElementById('site-header');
  const backdrop = document.getElementById('drawer-backdrop');

  let isDrawerOpen = false;

  function openDrawer() {
    if (isDrawerOpen) return;
    isDrawerOpen = true;
    document.body.style.overflow = 'hidden';
    backdrop.classList.add('is-open');
    siteHeader.classList.add('is-open');
    
    // Hide pickup button when drawer is open
    const pickupButton = document.getElementById('pickup-button-wrapper');
    if (pickupButton) {
      pickupButton.style.display = 'none';
    }
  }

  function closeDrawer() {
    if (!isDrawerOpen) return;
    isDrawerOpen = false;
    document.body.style.overflow = '';
    siteHeader.classList.remove('is-open');
    backdrop.classList.remove('is-open');
    
    // Show pickup button when drawer is closed
    const pickupButton = document.getElementById('pickup-button-wrapper');
    if (pickupButton) {
      pickupButton.style.display = '';
    }
  }

  // Event listeners using delegation to handle dynamically loaded buttons
  document.addEventListener('click', (e) => {
    // Handle drawer open button
    if (e.target.closest('#drawer-open')) {
      e.preventDefault();
      openDrawer();
    }
    
    // Handle drawer close button
    if (e.target.closest('#drawer-close')) {
      e.preventDefault();
      closeDrawer();
    }
  });

  if (backdrop) {
    backdrop.addEventListener('click', (e) => {
      e.preventDefault();
      closeDrawer();
    });
  }

  // Keyboard navigation
  window.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && isDrawerOpen) {
      closeDrawer();
    }
  });

  // Prevent body scroll when drawer is open
  function preventBodyScroll(e) {
    if (isDrawerOpen) {
      e.preventDefault();
    }
  }

  // Add touch event listeners for mobile
  if ('ontouchstart' in window) {
    document.addEventListener('touchmove', preventBodyScroll, { passive: false });
  }

  // Cart/Pickup Toggle Animations
  let previousCartCount = 0;
  
  // Initialize previous cart count from visible elements
  const initializeCartCount = () => {
    const container = document.getElementById('cart-pickup-container');
    if (!container) return;
    
    const pickupButton = container.querySelector('#pickup-button-wrapper');
    const miniCart = container.querySelector('#mini-cart-wrapper');
    const cartBadge = container.querySelector('.cart-count-badge');
    
    if (miniCart && miniCart.style.display !== 'none') {
      // Mini cart is visible, so we have items
      previousCartCount = cartBadge ? (parseInt(cartBadge.textContent) || 0) : 1;
    } else if (pickupButton && pickupButton.style.display !== 'none') {
      // Pickup button is visible, so cart is empty
      previousCartCount = 0;
    } else {
      // Fallback: check if badge exists and is not hidden
      if (cartBadge && !cartBadge.classList.contains('hidden')) {
        previousCartCount = parseInt(cartBadge.textContent) || 0;
      }
    }
  };
  
  initializeCartCount();

  // Listen for WooCommerce cart updates
  jQuery(document.body).on('added_to_cart removed_from_cart updated_cart_totals wc_fragments_refreshed wc_fragment_refresh', function(event, fragments, cart_hash, button) {
    // Use requestAnimationFrame for immediate DOM update check
    requestAnimationFrame(() => {
      const container = document.getElementById('cart-pickup-container');
      if (!container) return;

      const pickupButton = container.querySelector('#pickup-button-wrapper');
      const miniCart = container.querySelector('#mini-cart-wrapper');
      const cartBadge = container.querySelector('.cart-count-badge');
      
      // Determine current cart count based on which element is visible
      let currentCartCount = 0;
      if (miniCart && miniCart.style.display !== 'none') {
        // Mini cart is visible, so we have items
        currentCartCount = cartBadge ? (parseInt(cartBadge.textContent) || 0) : 1;
      } else if (pickupButton && pickupButton.style.display !== 'none') {
        // Pickup button is visible, so cart is empty
        currentCartCount = 0;
      }

      // Check if we need to transition (0 to 1+ or 1+ to 0)
      const shouldTransition = (previousCartCount === 0 && currentCartCount > 0) || 
                             (previousCartCount > 0 && currentCartCount === 0);

      if (shouldTransition && typeof gsap !== 'undefined') {
        // Fade out current element with faster animation
        const elementToHide = currentCartCount > 0 ? pickupButton : miniCart;
        const elementToShow = currentCartCount > 0 ? miniCart : pickupButton;

        if (elementToHide && elementToShow) {
          gsap.to(elementToHide, {
            opacity: 0,
            x: -15,
            duration: 0.15, // Faster fade out
            ease: 'power2.out',
            onComplete: () => {
              // After fade out, the new element should already be in DOM from fragment
              // Just animate it in with faster animation
              gsap.fromTo(elementToShow, 
                { opacity: 0, x: 15 },
                { opacity: 1, x: 0, duration: 0.15, ease: 'power2.out' } // Faster fade in
              );
            }
          });
        }
      }

      // Update previous cart count
      previousCartCount = currentCartCount;
    });
  });

  // Re-initialize after fragment updates to ensure animations work
  jQuery(document.body).on('wc_fragments_refreshed wc_fragments_loaded', function() {
    initializeCartCount();
  });

  // Simple Sticky Header - Regular sticky behavior after 250px
  const stickyThreshold = parseInt(document.getElementById('site-header')?.dataset?.stickyThreshold) || 250;
  const shouldBeStickyAttr = siteHeader.dataset.shouldBeSticky;
  
  // Check if sticky should be enabled (from PHP calculation)
  const isStickyEnabled = shouldBeStickyAttr === 'true';

  if (isStickyEnabled) {
    // Initialize state based on current scroll position
    let isSticky = window.scrollY >= stickyThreshold;
    
    // Set initial state
    if (isSticky) {
      siteHeader.classList.add('sticky');
    }
    
    function handleScroll() {
      const currentScrollY = window.scrollY;
      const shouldBeSticky = currentScrollY >= stickyThreshold;
      
      // Add sticky class when scrolled past threshold
      if (shouldBeSticky && !isSticky) {
        isSticky = true;
        siteHeader.classList.add('sticky');
      }
      // Remove sticky class when under threshold
      else if (!shouldBeSticky && isSticky) {
        isSticky = false;
        siteHeader.classList.remove('sticky');
      }
    }

    // Throttle scroll events for better performance
    let ticking = false;
    function requestTick() {
      if (!ticking) {
        requestAnimationFrame(handleScroll);
        ticking = true;
        setTimeout(() => { ticking = false; }, 16); // ~60fps
      }
    }

    // Add scroll listener
    window.addEventListener('scroll', requestTick, { passive: true });
    
    // Initialize scroll position
    handleScroll();
  }
}); 